import { render, staticRenderFns } from "./AMeasureActivityComment.vue?vue&type=template&id=7d55af18&"
import script from "./AMeasureActivityComment.vue?vue&type=script&lang=ts&"
export * from "./AMeasureActivityComment.vue?vue&type=script&lang=ts&"
import style0 from "./AMeasureActivityComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
